// Add stock-request context without changing the native contact form submission.
const params = new URLSearchParams(window.location.search);
const product = (params.getAll('product').at(-1) || '').trim();
const handle = params.getAll('handle').at(-1) || '';

if (/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) && handle === handle.trim() && product.length > 0 && product.length <= 200) {
  const size = (params.getAll('maat').at(-1) || '').trim().slice(0, 100);
  const variant = params.getAll('variant').at(-1) || '';
  const productLink = `${window.location.origin}/products/${handle}${variant && !/[^0-9]/.test(variant) ? `?variant=${variant}` : ''}`;
  const description = `${product}${size ? ` (maat ${size})` : ''}`;

  document.querySelectorAll('.contact-page__form').forEach((form) => {
    for (const [name, value] of [['Product', product], ['Maat', size], ['Productlink', productLink]]) {
      const input = form.querySelector(`[name="contact[${name}]"]`);
      if (input) {
        input.value = value;
        input.disabled = !value;
      }
    }

    const notice = form.querySelector('[data-stock-request]');
    if (notice) {
      notice.textContent = `Je vraagt naar: ${description}`;
      notice.hidden = false;
    }

    const body = form.querySelector('[name="contact[body]"]');
    if (body && body.value === '') {
      body.value = `Graag een seintje als ${description} weer op voorraad is.`;
    }
  });
}
